import styled from 'styled-components';
import { Button, useToast } from '@/ui';
import { useCreatorsHub } from '@/hooks';
import { HubIdentity } from '../HubIdentity';

const List = styled.div` display: flex; flex-direction: column; gap: 12px; `;
const Card = styled.article`
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.glassBg};
  padding: 14px;
`;
const Text = styled.p` margin: 10px 0; color: ${({ theme }) => theme.color.textPrimary}; font-size: ${({ theme }) => theme.fontSize.sm}; `;
const Actions = styled.div` display: flex; gap: 8px; `;
const Empty = styled.p` color: ${({ theme }) => theme.color.textMuted}; padding: 24px 0; `;

export function InvitesTab() {
  const { invites, acceptInvite, declineInvite } = useCreatorsHub();
  const toast = useToast();
  if (invites.length === 0) return <Empty>No pending invites.</Empty>;
  return (
    <List>
      {invites.map((i) => (
        <Card key={i.id}>
          <HubIdentity name={i.name} handle={i.handle} av={i.av} />
          <Text>{i.text}</Text>
          <Actions>
            <Button variant="outline" onClick={() => { void acceptInvite(i.id); toast('Invite accepted'); }}>Accept</Button>
            <Button variant="ghost" onClick={() => { void declineInvite(i.id); toast('Invite declined'); }}>Decline</Button>
          </Actions>
        </Card>
      ))}
    </List>
  );
}
